(function () {
  'use strict';

  var CUP_ORDER = ['AAA', 'AA', 'A', 'B', 'C'];
  var TOP_SIZES = ['XS', 'S', 'M', 'L'];
  var BOTTOM_SIZES = ['XS', 'S', 'M', 'L'];
  var ONE_PIECE_SIZES = ['XS', 'S', 'M', 'L'];

  function parseCup(value) {
    var normalized = String(value || '').trim().toUpperCase();
    if (!normalized) return null;
    if (CUP_ORDER.indexOf(normalized) === -1) return null;
    return normalized;
  }

  function parseNumber(value) {
    var num = parseFloat(String(value || '').trim());
    return isNaN(num) ? null : num;
  }

  function inRange(value, min, max) {
    return value >= min && value <= max;
  }

  function cupInRange(cup, minCup, maxCup) {
    return CUP_ORDER.indexOf(cup) >= CUP_ORDER.indexOf(minCup) &&
      CUP_ORDER.indexOf(cup) <= CUP_ORDER.indexOf(maxCup);
  }

  function pickLastMatchingSize(rules, matchFn) {
    var matched = null;
    rules.forEach(function (rule) {
      if (matchFn(rule)) matched = rule.size;
    });
    return matched;
  }

  function recommendTopSize(band, cup) {
    if (band == null || !cup) return null;

    var rules = [
      { size: 'XS', band: [25, 29], cup: ['AAA', 'A'] },
      { size: 'S', band: [29, 34], cup: ['AA', 'A'] },
      { size: 'M', band: [34, 39], cup: ['A', 'B'] },
      { size: 'L', band: [38, 41], cup: ['B', 'C'] }
    ];

    return pickLastMatchingSize(rules, function (rule) {
      return inRange(band, rule.band[0], rule.band[1]) &&
        cupInRange(cup, rule.cup[0], rule.cup[1]);
    });
  }

  function recommendBottomSize(hip) {
    if (hip == null) return null;

    var rules = [
      { size: 'XS', hip: [29, 32] },
      { size: 'S', hip: [32, 35] },
      { size: 'M', hip: [35, 38] },
      { size: 'L', hip: [38, 41] }
    ];

    return pickLastMatchingSize(rules, function (rule) {
      return inRange(hip, rule.hip[0], rule.hip[1]);
    });
  }

  function recommendOnePieceSize(overBust, hip) {
    if (overBust == null || hip == null) return null;

    var rules = [
      { size: 'XS', bust: [25, 31], hip: [29, 32] },
      { size: 'S', bust: [32, 35], hip: [32, 35] },
      { size: 'M', bust: [36, 39], hip: [35, 38] },
      { size: 'L', bust: [38, 41], hip: [38, 41] }
    ];

    var bustSize = pickLastMatchingSize(rules, function (rule) {
      return inRange(overBust, rule.bust[0], rule.bust[1]);
    });
    var hipSize = pickLastMatchingSize(rules, function (rule) {
      return inRange(hip, rule.hip[0], rule.hip[1]);
    });

    if (!bustSize || !hipSize) return null;
    if (bustSize === hipSize) return bustSize;

    var bustIndex = ONE_PIECE_SIZES.indexOf(bustSize);
    var hipIndex = ONE_PIECE_SIZES.indexOf(hipSize);
    return ONE_PIECE_SIZES[Math.max(bustIndex, hipIndex)];
  }

  function normalizeSizeToken(value) {
    return String(value || '').trim().split(/[\s/]/)[0].toUpperCase();
  }

  function findVariantForSize(productData, sizeLabel) {
    if (!productData || !sizeLabel) return null;

    var availableVariant = productData.variants.find(function (variant) {
      return variant.options.some(function (optionValue) {
        return normalizeSizeToken(optionValue) === sizeLabel;
      }) && variant.available;
    });

    if (availableVariant) {
      return { variant: availableVariant, status: 'available' };
    }

    var soldOutVariant = productData.variants.find(function (variant) {
      return variant.options.some(function (optionValue) {
        return normalizeSizeToken(optionValue) === sizeLabel;
      });
    });

    if (soldOutVariant) {
      return { variant: soldOutVariant, status: 'sold_out' };
    }

    return { variant: null, status: 'missing' };
  }

  function selectVariantOnPage(productForm, variant) {
    if (!productForm || !variant) return false;

    productForm.querySelectorAll('.option-selector').forEach(function (selector) {
      var optionIndex = parseInt(selector.dataset.optionIndex, 10);
      var targetValue = variant.options[optionIndex];
      var selectorType = selector.dataset.selectorType;

      if (selectorType === 'listed') {
        selector.querySelectorAll('.js-option').forEach(function (input) {
          input.checked = input.value === targetValue;
        });
      } else if (selectorType === 'dropdown') {
        var customSelect = selector.querySelector('.cc-select');
        if (customSelect) {
          customSelect.dispatchEvent(new CustomEvent('selectOption', {
            detail: { value: targetValue }
          }));
        }
      }
    });

    var multiOption = productForm.querySelector('.option-selectors');
    if (multiOption) {
      multiOption.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  }

  function addCurrentProductToCart(productForm) {
    var purchaseForm = productForm.querySelector('form.product-purchase-form');
    if (!purchaseForm) return;

    if (window.theme) {
      window.theme.skipSizeChartOnAdd = true;
    }

    if (window.theme && window.theme.settings && window.theme.settings.cart_type === 'drawer' &&
      productForm.getAttribute('data-ajax-add-to-cart') === 'true' &&
      window.theme.ajaxAddToCartDrawerFromForm) {
      window.theme.ajaxAddToCartDrawerFromForm(window.jQuery(purchaseForm), window.jQuery(productForm));
      return;
    }

    purchaseForm.submit();
  }

  function FindMySizeModal(root) {
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-find-my-size-config]').textContent);
    this.productForm = document.querySelector('.product-form[data-product-id="' + this.config.productId + '"]');
    this.productData = null;

    this.trigger = root.querySelector('[data-find-my-size-open]');
    this.modal = root.querySelector('[data-find-my-size-modal]');
    this.backdrop = root.querySelector('[data-find-my-size-close]');
    this.closeBtn = root.querySelector('[data-find-my-size-close-btn]');
    this.result = root.querySelector('[data-find-my-size-result]');
    this.resultSize = root.querySelector('[data-find-my-size-result-size]');
    this.resultCopy = root.querySelector('[data-find-my-size-result-copy]');
    this.between = root.querySelector('[data-find-my-size-between]');
    this.cta = root.querySelector('[data-find-my-size-cta]');

    this.recommendedSize = null;
    this.recommendedVariant = null;

    this.bindEvents();
    this.updateRecommendation();
  }

  FindMySizeModal.prototype.getProductData = function () {
    if (this.productData) return this.productData;
    var jsonEl = document.getElementById('ProductJson-' + this.config.productId);
    if (!jsonEl) return null;
    this.productData = JSON.parse(jsonEl.textContent);
    return this.productData;
  };

  FindMySizeModal.prototype.bindEvents = function () {
    var self = this;

    this.trigger.addEventListener('click', function () {
      self.open();
    });

    [this.backdrop, this.closeBtn].forEach(function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });

    this.root.querySelectorAll('[data-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.handleStep(button);
      });
    });

    this.root.querySelectorAll('[data-find-my-size-input]').forEach(function (input) {
      ['input', 'change', 'blur'].forEach(function (eventName) {
        input.addEventListener(eventName, function () {
          self.updateRecommendation();
        });
      });
    });

    this.cta.addEventListener('click', function () {
      self.handleAddToCart();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal.classList.contains('is-open')) {
        self.close();
      }
    });
  };

  FindMySizeModal.prototype.handleStep = function (button) {
    var targetName = button.getAttribute('data-target');
    var direction = button.getAttribute('data-step');
    var input = this.root.querySelector('[data-find-my-size-input="' + targetName + '"]');
    if (!input) return;

    if (targetName === 'cup') {
      var cup = parseCup(input.value) || 'A';
      var index = CUP_ORDER.indexOf(cup);
      if (direction === 'up' && index < CUP_ORDER.length - 1) index += 1;
      if (direction === 'down' && index > 0) index -= 1;
      input.value = CUP_ORDER[index];
    } else {
      var current = parseNumber(input.value);
      if (current == null) current = parseNumber(input.getAttribute('data-default')) || 32;
      var min = parseNumber(input.getAttribute('min')) || 20;
      var max = parseNumber(input.getAttribute('max')) || 50;
      var step = parseNumber(input.getAttribute('step')) || 1;
      current += direction === 'up' ? step : -step;
      current = Math.max(min, Math.min(max, current));
      input.value = String(Math.round(current));
    }

    this.updateRecommendation();
  };

  FindMySizeModal.prototype.getRecommendedSize = function () {
    var type = this.config.type;

    if (type === 'top') {
      var bandInput = this.root.querySelector('[data-find-my-size-input="band"]');
      var cupInput = this.root.querySelector('[data-find-my-size-input="cup"]');
      return recommendTopSize(parseNumber(bandInput && bandInput.value), parseCup(cupInput && cupInput.value));
    }

    if (type === 'bottom') {
      var hipInput = this.root.querySelector('[data-find-my-size-input="hip"]');
      return recommendBottomSize(parseNumber(hipInput && hipInput.value));
    }

    if (type === 'one_piece') {
      var bustInput = this.root.querySelector('[data-find-my-size-input="over_bust"]');
      var hipInputOnePiece = this.root.querySelector('[data-find-my-size-input="hip"]');
      return recommendOnePieceSize(
        parseNumber(bustInput && bustInput.value),
        parseNumber(hipInputOnePiece && hipInputOnePiece.value)
      );
    }

    return null;
  };

  FindMySizeModal.prototype.updateRecommendation = function () {
    if (!this.result || !this.resultSize || !this.resultCopy || !this.cta) return;

    var size = this.getRecommendedSize();
    var hasValidInput = this.hasValidInput();
    var variantMatch = size ? findVariantForSize(this.getProductData(), size) : null;

    this.recommendedSize = size;
    this.recommendedVariant = variantMatch ? variantMatch.variant : null;

    this.result.classList.remove('find-my-size-modal__result--no-match', 'find-my-size-modal__result--unavailable');

    if (size && this.recommendedVariant && this.recommendedVariant.available) {
      this.result.classList.add('is-visible');
      this.resultSize.textContent = 'Your size: ' + size;
      this.resultCopy.textContent = this.config.resultCopy || '';
      this.cta.textContent = 'Add to cart - Size ' + size + ' \u2192';
      this.cta.disabled = false;
      if (this.between) this.between.classList.remove('is-hidden');
      return;
    }

    if (size && this.recommendedVariant && !this.recommendedVariant.available) {
      this.result.classList.add('is-visible', 'find-my-size-modal__result--unavailable');
      this.resultSize.textContent = 'Your size: ' + size;
      this.resultCopy.textContent = this.config.unavailableMessage || 'This size is not available right now.';
      this.cta.textContent = 'Add to cart - Size ' + size + ' \u2192';
      this.cta.disabled = true;
      if (this.between) this.between.classList.remove('is-hidden');
      return;
    }

    if (size && !this.recommendedVariant) {
      this.result.classList.add('is-visible', 'find-my-size-modal__result--unavailable');
      this.resultSize.textContent = 'Your size: ' + size;
      this.resultCopy.textContent = this.config.unavailableMessage ||
        'This size is not available on this product right now.';
      this.cta.textContent = 'Add to cart - Size ' + size + ' \u2192';
      this.cta.disabled = true;
      if (this.between) this.between.classList.remove('is-hidden');
      return;
    }

    if (hasValidInput) {
      this.result.classList.add('is-visible', 'find-my-size-modal__result--no-match');
      this.resultSize.textContent = 'No size match';
      this.resultCopy.textContent = this.config.noMatchMessage ||
        'We could not find a Sabal size for these measurements. Try our Fit Finder or contact us for help.';
      this.cta.textContent = 'Add to cart';
      this.cta.disabled = true;
      if (this.between) this.between.classList.add('is-hidden');
      return;
    }

    this.result.classList.remove('is-visible');
    this.cta.textContent = 'Add to cart';
    this.cta.disabled = true;
    if (this.between) this.between.classList.remove('is-hidden');
  };

  FindMySizeModal.prototype.hasValidInput = function () {
    var type = this.config.type;

    if (type === 'top') {
      var bandInput = this.root.querySelector('[data-find-my-size-input="band"]');
      var cupInput = this.root.querySelector('[data-find-my-size-input="cup"]');
      return parseNumber(bandInput && bandInput.value) != null &&
        parseCup(cupInput && cupInput.value) != null;
    }

    if (type === 'bottom') {
      var hipInput = this.root.querySelector('[data-find-my-size-input="hip"]');
      return parseNumber(hipInput && hipInput.value) != null;
    }

    if (type === 'one_piece') {
      var bustInput = this.root.querySelector('[data-find-my-size-input="over_bust"]');
      var hipInputOnePiece = this.root.querySelector('[data-find-my-size-input="hip"]');
      return parseNumber(bustInput && bustInput.value) != null &&
        parseNumber(hipInputOnePiece && hipInputOnePiece.value) != null;
    }

    return false;
  };

  FindMySizeModal.prototype.open = function () {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.updateRecommendation();
  };

  FindMySizeModal.prototype.close = function () {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  FindMySizeModal.prototype.handleAddToCart = function () {
    if (!this.recommendedVariant || !this.productForm) return;

    selectVariantOnPage(this.productForm, this.recommendedVariant);
    addCurrentProductToCart(this.productForm);
    this.close();
  };

  function initFindMySize() {
    document.querySelectorAll('[data-find-my-size-root]').forEach(function (root) {
      if (root.dataset.findMySizeInit === 'true') return;
      root.dataset.findMySizeInit = 'true';
      new FindMySizeModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFindMySize);
  } else {
    initFindMySize();
  }

  document.addEventListener('shopify:section:load', initFindMySize);
})();
